import axios, { AxiosResponse } from 'axios';

import { ETypPrevodu } from 'services/specialniSluzby/uePozadavky';
import { EZadostPravoZastupuje } from 'services/spravaEmitenta/zadostPravo';

import {
    EPodTypDokumentu,
    EStavPodpisu,
    EStavZadostiDok,
    ETypDokumentu,
    ETypZpusobPredani
} from 'enums/dokumentyEnums';
import { ECisalikvynos } from 'enums/isin/udaje/cisalikvynos';
import { EDruhAkcie } from 'enums/isin/udaje/druhAkcie';
import { EDruhCp } from 'enums/isin/udaje/druhCp';
import { EFrekvenceVyplaty } from 'enums/isin/udaje/frekvenceVyplaty';
import { EUrokovaSazba } from 'enums/isin/udaje/urokovaSazba';
import { EZarucenieEmise } from 'enums/isin/udaje/zarucenieEmise';

import { IDodatekAdmin, IDodatekDFPUcet } from './dodatek';
import { EOmezPrevodVyjadreni } from './omezPrevoditelnost';
import { IDokumentyPrehledInput } from './smlouva';

type DateTimeString = string;

export enum ETypPrikazuDuvod {
    SPLATNOST = 'SPLATNOST', // splatnost dluhopisu
    PREDSPL = 'PREDSPL', // předčasná splatnost dluhopisu
    LIKVIDACE = 'LIKVIDACE', // likvidace akciové společnosti
    PREMENACP = 'PREMENACP', // přeměna na cenný papír (listinný)
    PREMENASP = 'PREMENASP', // přeměna společnosti na s.r.o.
    FUZE = 'FUZE', // fúze společnosti
    ZMENOSOBA = 'ZMENOSOBA', // změna osoby vedoucí evidenci
    JINY = 'JINY' // jiný důvod
}
export enum EEmiseKdni {
    PRED = 'PRED', // ke dni předcházejícímu datu zrušení emise
    JINY = 'JINY' // k jinému datu
}

export enum EPredaniMajitaelu {
    CDCP = 'CDCP', // Seznam ke snížení zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři
    MD = 'MD', // Seznam podaný emitentem prostřednictvím webového portálu Můj depozitář
    MDADMIN = 'MDADMIN' // Seznam předaný administrátorem emise prostřednictvím webového portálu Můj depozitář
}
export enum EZpusobPodani {
    CDCP = 'CDCP', // Prostřednictvím žádosti doručené centrálnímu depozitáři
    MD = 'MD', // Prostřednictvím aplikace Můj depozitář
    NEPOZADUJE = 'NEPOZADUJE' // Emitent nepožaduje výpis z emise
}
export enum EDuvodZnizeni {
    ZRUSAKCZK = 'ZRUSAKCZK', //  Zrušení akcií v důsledku snížení základního kapitálu
    ZRUSAKINV = 'ZRUSAKINV', // Zrušení akcií investičních fondů
    SNIZDLUH = 'SNIZDLUH', //  Snížení počtu zaknihovaných dluhopisů zrušením
    SNIZINV = 'SNIZINV', //  Snížení počtu zaknihovaných investičních certifikátů
    SNIZWAR = 'SNIZWAR', //  Snížení počtu zaknihovaných warrantů
    SNIZJINY = 'SNIZJINY' //  Snížení počtu jiných zaknihovaných cenných papírů
}

export enum EduvodZmenyHodnoty {
    SNIZENI = 'SNIZENI', // Rozhodnutí valné hromady o snížení základního kapitálu
    ZVYSENI = 'ZVYSENI', // Rozhodnutí valné hromady o zvýšení základního kapitálu
    SCHUZE = 'SCHUZE', // Rozhodnutí schůze vlastníků dluhopisů
    JINE = 'JINE' // Jiné rozhodnutí
}
export interface IPrikazPrechod {
    idprechod?: number;
    datum: DateTimeString;
    typzpusob: EZpusobPodani;
    datumvypis: DateTimeString;
    datumzapis: DateTimeString;
    navakcie: number;
    pocetcp: number;
    poccphlav: number;
    prechisin: [
        {
            isin: string;
        }
    ];
}

export const PrikazPrechodGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/prechod`
    }).then((resp: AxiosResponse<IPrikazPrechod>) => resp.data);
};
export const PrikazPrechodPut = (id: number | string, data: IPrikazPrechod) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/prechod`,
        data: data
    });
};

export interface IPrikazPrevod {
    idprevod?: number;
    datum: DateTimeString;
    isin: string;
    typ: 'ZAPIS' | 'ZRUSENI';
    popisomezeni: string;
}

export const PrikazPrevodGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/prevod`
    }).then((resp: AxiosResponse<IPrikazPrevod>) => resp.data);
};
export const PrikazPrevodPut = (id: number | string, data: IPrikazPrevod) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/prevod`,
        data: data
    });
};

export interface IPrikazSnizeni {
    idsnizeni?: number;
    datum: DateTimeString;
    isin: string;
    typduvod: EDuvodZnizeni;
    navakcie: number;
    mena: string;
    pocetcpp: number;
    pocetcpn: number;
    snizpoccp: number;
    poccpsniz: number;
    celkhodnotap: number;
    celkhodnota: number;
    typsezmaj: EPredaniMajitaelu;
    snizeniucet?: [
        {
            iducet: number;
            cdac: string;
            rcma: string;
            idma: string;
            qtet: number;
            idmb: string;
            pjma: string;
            jmma: string;
            ttma: string;
            rliv: string;
            ppn: boolean;
        }
    ];
}

export const PrikazSnizeniGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/snizeni`
    }).then((resp: AxiosResponse<IPrikazSnizeni>) => resp.data);
};
export const PrikazSnizeniPut = (id: number | string, data: IPrikazSnizeni) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/snizeni`,
        data: data
    });
};

export interface IPrikazSplynutiVznik {
    isin?: string;
    navakcie?: number;
    celkhodnota?: number;
    pocetcpp?: number;
    pocetcpn?: number;
}
export interface IPrikazSplynuti {
    idsplynuti?: number;
    datum: DateTimeString;
    nahrsezakc: boolean;
    zanik: {
        isin: string;
    }[];
    vznik: IPrikazSplynutiVznik[];
}

export const PrikazSplynutiGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/splynuti`
    }).then((resp: AxiosResponse<IPrikazSplynuti>) => resp.data);
};
export const PrikazSplynutiPut = (id: number | string, data: IPrikazSplynuti) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/splynuti`,
        data: data
    });
};

export interface IPrikazStepeni {
    idstepeni?: number;
    datum: DateTimeString;
    isin: string;
    hodnotap: number;
    hodnotan: number;
    menap: string;
    menan: string;
    pocetcpp: number;
    pocetcpn: number;
    pomer: number;
    celkhodnota: number;
}

export const PrikazStepeniGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/stepeni`
    }).then((resp: AxiosResponse<IPrikazStepeni>) => resp.data);
};
export const PrikazStepeniPut = (id: number | string, data: IPrikazStepeni) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/stepeni`,
        data: data
    });
};

export interface IPrikazZmenForm {
    idzmenformu?: number;
    datum: DateTimeString;
    isin: string;
    formap: 'NADORUCITELE' | 'NARAD';
    forman: 'NADORUCITELE' | 'NARAD';
    druhp: EDruhAkcie;
    druhn: EDruhAkcie;
    zvlpravop: string;
    zvlpravon: string;
}

export const PrikazZmenFormGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenform`
    }).then((resp: AxiosResponse<IPrikazZmenForm>) => resp.data);
};
export const PrikazZmenFormPut = (id: number | string, data: IPrikazZmenForm) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenform`,
        data: data
    });
};

export interface IPrikazZmenHodn {
    idzmenhodn?: number;
    datum: DateTimeString;
    isin: string;
    duvodzmeny: EduvodZmenyHodnoty;
    rozhodnuti: string;
    hodnotap: number;
    hodnotan: number;
    menap: string;
    menan: string;
    pocetcpp: number;
    pocetcpn: number;
    celkhodnota: number;
}

export const PrikazZmenHodnGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenhodn`
    }).then((resp: AxiosResponse<IPrikazZmenHodn>) => resp.data);
};
export const PrikazZmenHodnPut = (id: number | string, data: IPrikazZmenHodn) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenhodn`,
        data: data
    });
};

export interface IPrikazZmenit {
    idzmenit?: number;
    datum: DateTimeString;
    znazev: boolean;
    zadresa: boolean;
    zemailfakt: boolean;
    zemailpopl: boolean;
    zjina: boolean;
    popis: string;
    nazevp: string;
    nazevn: string;
    admap: string;
    adman: string;
    memap: string;
    meman: string;
    pscmp: string;
    pscmn: string;
    kostp: string;
    kostn: string;
    emailfaktp: string;
    emailfaktn: string;
    emailpoplp: string;
    emailpopln: string;
}

export const PrikazZmenitGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenemit`
    }).then((resp: AxiosResponse<IPrikazZmenit>) => resp.data);
};
export const PrikazZmenitPut = (id: number | string, data: IPrikazZmenit) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenemit`,
        data: data
    });
};

export interface IZruseniPrikaz {
    idzruseni?: number;
    datum: DateTimeString;
    isin: string;
    typduvod: ETypPrikazuDuvod;
    clanek: string;
    osobap: string;
    osoban: string;
    popisduvod: string;
    typkedni: EEmiseKdni;
    kedni: DateTimeString;
    blokace: boolean;
    typzpusob: EZpusobPodani;
    vypis: boolean;
    potvrlikv: boolean;
    jinaosobap?: string;
    jinaosoban?: string;
}

export const PrikazZruseniGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zruseni`
    }).then((resp: AxiosResponse<IZruseniPrikaz>) => resp.data);
};
export const PrikazZruseniPut = (id: number | string, data: IZruseniPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zruseni`,
        data: data
    });
};

export interface IZmenregiPrikaz {
    idzruseni?: number;
    datum: DateTimeString;
    isin: string;
    osobap: string;
    osoban: string;
    potvrlikv: boolean;
    jinaosobap?: string;
    jinaosoban?: string;
    souhlas: boolean;
}

export const PrikazZmenregiGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenregi`
    }).then((resp: AxiosResponse<IZmenregiPrikaz>) => resp.data);
};
export const PrikazZmenregiPut = (id: number | string, data: IZmenregiPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenregi`,
        data: data
    });
};

export const PrikazZmenaAdminGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenadmin`
    }).then((resp: AxiosResponse<IDodatekAdmin>) => resp.data);
};
export const PrikazZmenaAdminPut = (id: number | string, data: IDodatekAdmin) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenadmin`,
        data: data
    });
};

export interface IZruseniAdminPrikaz {
    isin: string;
    datum: DateTimeString;
    idmb: string;
    nazev: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
}

export const PrikazZrusAdminGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zrusadmin`
    }).then((resp: AxiosResponse<IZruseniAdminPrikaz>) => resp.data);
};
export const PrikazZrusAdminPut = (id: number | string, data: IZruseniAdminPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zrusadmin`,
        data: data
    });
};

export interface IZruseniPpnPrikaz {
    idzrusppn: number;
    datum: DateTimeString;
    isin: string;
    zrusitppn: 'NAVSECHUCT' | 'NAUCTMAJIT';
    ucty: {
        ucty: IDodatekDFPUcet[];
        celkemcp: number;
    };
}
export interface IZruseniPpnPrikazPut {
    datum: DateTimeString;
    isin: string;
    zrusitppn: 'NAVSECHUCT' | 'NAUCTMAJIT';
}
export const PrikazZrusPpnGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zrusppn`
    }).then((resp: AxiosResponse<IZruseniPpnPrikaz>) => resp.data);
};
export const PrikazZrusPpnPut = (id: number | string, data: IZruseniPpnPrikazPut) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zrusppn`,
        data: data
    });
};

export interface IProdlouzeniPrikaz {
    idzrusppn: number;
    datum: DateTimeString;
    isin: string;
    duvodprodluz: 'ROZHODNUTI' | 'JINY';
    duvod: string;
    datsplatp: DateTimeString;
    datsplatn: DateTimeString;
}

export const PrikazProdlouzeniGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/prodluz`
    }).then((resp: AxiosResponse<IProdlouzeniPrikaz>) => resp.data);
};
export const PrikazProdlouzeniPut = (id: number | string, data: IProdlouzeniPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/prodluz`,
        data: data
    });
};

export interface IZmenEmisiPrikaz {
    datum: DateTimeString;
    isin: string;
    nav: boolean;
    navakciep: number;
    navakcien: number;
    menap: string;
    menan: string;
    datkurzup: DateTimeString;
    datkurzun: DateTimeString;
    uroktyp: boolean;
    uroktypp: EUrokovaSazba;
    uroktypn: EUrokovaSazba;
    sazba: number;
    urokpopis: string;
    uroktypsazba: number;
    uroktyppopis: string;
    urokvyse: boolean;
    sazbap: number;
    sazban: number;
    uroksazba: boolean;
    urokpopisp: string;
    urokpopisn: string;
    sazbaplatnostpopis: DateTimeString;
    sazbaplatnost: DateTimeString;
    standard: boolean;
    standardp: ECisalikvynos;
    standardn: ECisalikvynos;
    standardpopis: string;
    jiny: boolean;
    jinyudaj: string;
    frekvence: boolean;
    frekvencep: EFrekvenceVyplaty;
    frekvencen: EFrekvenceVyplaty;
    pocdnijist: number;
    typdatjist: 'KUPON' | 'JINE';
    pocdnikup: number;
    datjist: DateTimeString;
    datexjist: DateTimeString;
    zaruceniemise: boolean;
    zaruceniemisep: EZarucenieEmise;
    zaruceniemisen: EZarucenieEmise;
    zmendatkup: {
        datrozhkup: DateTimeString;
        datexkup: DateTimeString;
    }[];
}
export const PrikazZmenEmisiGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zmenemisi`
    }).then((resp: AxiosResponse<IZmenEmisiPrikaz>) => resp.data);
};
export const PrikazZmenEmisiPut = (id: number | string, data: IZmenEmisiPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zmenemisi`,
        data: data
    });
};

export interface IZapisBlokPrikaz {
    idzmenemisi: number;
    datum: DateTimeString;
    isin: string;
}
export const PrikazZapisBlokGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/zapisblok`
    }).then((resp: AxiosResponse<IZapisBlokPrikaz>) => resp.data);
};
export const PrikazZapisBlokPut = (id: number | string, data: IZapisBlokPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/zapisblok`,
        data: data
    });
};

export interface ISeznamPrikaz {
    souhlas?: boolean;
    datum: DateTimeString;
    isin: string;
    zpuspredvp?: ETypZpusobPredani;
    zpuspredfp?: ETypZpusobPredani;
    typprevodu: ETypPrevodu;
    idsezupisdvp: number;
    celkcastka: number;
    celkpocupis: number;
    typplatby: 'TUP' | 'ZAP';
    castka: number;
    mena: string;
    predcisli: string;
    cislouctu: string;
    banka: string;
    iban: string;
    bic: string;
    nazprij: string;
    adrprij1?: string;
    adrprij2?: string;
    adrprij3?: string;
    adrprij4?: string;
    bicprij?: string;
}
export const PrikazSeznamGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/sezupisdvp`
    }).then((resp: AxiosResponse<ISeznamPrikaz>) => resp.data);
};
export const PrikazSeznamPut = (id: number | string, data: ISeznamPrikaz) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/sezupisdvp`,
        data: data
    });
};

export interface IDokZapisPpn {
    datum: DateTimeString;
    isin: string;
    alinearid: string;
    souhlas: boolean;
}

export const dokZapisPpnGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/prevodnasl`
    }).then((resp: AxiosResponse<IDokZapisPpn>) => resp.data);
};

export const dokZapisPpnPut = (id: number, data: IDokZapisPpn) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/prevodnasl`,
        data: data
    });
};
export interface IDokZrusZapisPpn {
    datum: DateTimeString;
    isin: string;
    zrusitppn: 'NAVSECHUCT' | 'NAUCTMAJIT';
    forma: ETypPrevodu.BEZZAPLACENI | ETypPrevodu.PROTIZAPLACENI;
    souhlas: boolean;
    alinearid: string;
}

export const dokZrusZapisPpnGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/prevodzpet`
    }).then((resp: AxiosResponse<IDokZrusZapisPpn>) => resp.data);
};

export const dokZrusZapisPpnPut = (id: number, data: IDokZrusZapisPpn) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/prevodzpet`,
        data: data
    });
};

export interface IZmenaJina {
    datum: DateTimeString;
    isin: string;
    idmb: string;
    nazev: string;
    popis?: string;
    souhlas: boolean;
}
export interface ILikvidacePrikaz extends IZmenaJina {
    typduvod: 'LIKVIDACE';
    typzpusob: 'CDCP' | 'NEPOZADUJE';
    vypis: boolean;
    potvrlikv: boolean;
}
const getJinaOsobaType = (type: string) =>
    type === 'likvidace'
        ? 'zruslikv'
        : type === 'fuze'
          ? 'zrusfuze'
          : type === 'prevzeti'
            ? 'zmenfuze'
            : type === 'list'
              ? 'zruslist'
              : 'zmenjina';

export const PrikazLikvidaceGet = (id: number | string, type: string) => {
    return axios({
        method: 'GET',
        url: `/DOKjiny/${id}/${getJinaOsobaType(type)}`
    }).then((resp: AxiosResponse<ILikvidacePrikaz>) => resp.data);
};
export const PrikazLikvidacePut = (id: number | string, data: ILikvidacePrikaz, type: string) => {
    return axios({
        method: 'PUT',
        url: `/DOKjiny/${id}/${getJinaOsobaType(type)}`,
        data: data
    });
};

export enum EZpusobPrevzati {
    OSOBUSB = 'OSOBUSB',
    OSOBLIST = 'OSOBLIST',
    POSTAUSB = 'POSTAUSB',
    POSTALIST = 'POSTALIST',
    MD = 'MD',
    DATOVKA = 'DATOVKA'
}

export interface IDokumentyJinyPrikaz {
    iddok: number;
    typ: ETypDokumentu;
    podtyp: EPodTypDokumentu;
    stav: EStavZadostiDok;
    vyjadrenicdcp: string;
    zmenadatum: DateTimeString;
    isin: string;
    druhcp: EDruhCp;
    nazevsouboru: string;
    idmb: string;
    emitent: string;
}
export interface IDokumentyJinaPrehled {
    count: number;
    order: string;
    limit: number;
    offset: number;
    dokumenty: IDokumentyJinyPrikaz[];
    smlouvy: [];
}

export const dokumentJinaPrehled = (params?: IDokumentyPrehledInput) => {
    return axios({
        method: 'GET',
        url: '/DOKjiny/prehled',
        params: params
    }).then((resp: AxiosResponse<IDokumentyJinaPrehled>) => resp.data);
};

export interface IVypisJina {
    idvypis: number;
    datum: DateTimeString;
    isin: string;
    druh: 'F45';
    kategorie: 'OBA' | 'JEDEN';
    zastava: boolean;
    esm: boolean;
    bankucet: boolean;
    majucet: boolean;
    datovka?: string;
    zpusob: EZpusobPrevzati;
    jmeno: string;
    prijmeni: string;
    rodnecislo: string;
    nazev: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
    email: string;
    souhlas: boolean;
    idmb: string;
    nazevemitenta: string;
}
export const PrikazVypisJinyGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKjiny/${id}/vypis`
    }).then((resp: AxiosResponse<IVypisJina>) => resp.data);
};
export const PrikazVypisJinyPut = (id: number | string, data: IVypisJina) => {
    return axios({
        method: 'PUT',
        url: `/DOKjiny/${id}/vypis`,
        data: data
    });
};

export interface IDokJinaInfo {
    spolecnost: {
        idmb: string;
        nazev: string;
        //  dicdph: string;
        // lei: string;
        adma: string;
        mema: string;
        pscm: string;
        kost: string;
        nace: string;
        /*  predcisli: string;
        cislouctu: string;
        banka: string;
        iban: string; */
    };
    osobazast: {
        jmeno: string;
        prijmeni: string;
        email: string;
        telefon: string;
    };
}

export const dokJinaZalozeniApi = (data: {
    idmb: string;
    nazev: string;
    stat: string;
    typ: ETypDokumentu;
    podtyp: EPodTypDokumentu;
}) => {
    return axios({
        method: 'POST',
        url: '/DOKjiny/dokument',
        data: data
    }).then((resp: AxiosResponse<{ id: number; stav: string }>) => resp.data);
};

export const dokJinaInfoGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKjiny/${id}/podava`
    }).then((resp: AxiosResponse<IDokJinaInfo>) => resp.data);
};

export const dokJinaInfoPut = (id: number, data: IDokJinaInfo) => {
    return axios({
        method: 'PUT',
        url: `/DOKjiny/${id}/podava`,
        data: data
    });
};

export interface IDokJinaOsoba {
    id: number;
    zadostoid: number;
    jmeno: string;
    prijmeni: string;
    email: string;
    telefon: string;
    emitentazas: EZadostPravoZastupuje;
    fileoid: number;
    c2dokosobaoid: number;
    uzivateloid: number;
    poradi: number;
    podepisuje: boolean;
    stavpodpisu: EStavPodpisu;
    typpodpisu: 'CERT' | 'BI';
    datdanokpodp: DateTimeString;
    podepsano: DateTimeString;
    ceriss: string;
    cersn: string;
    cerdn: string;
    bisub: string;
    refover: boolean;
}

export const dokJinaOsobyGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKjiny/${id}/osoby`
    }).then((resp: AxiosResponse<{ osoby: IDokJinaOsoba[] }>) => resp.data);
};

export const dokJinaOsoba = (id: number | string, idOsoba: number | string, method: 'GET' | 'DELETE') => {
    return axios({
        method: method,
        url: `/DOKjiny/${id}/osoba/${idOsoba}`
    }).then((resp: AxiosResponse<IDokJinaOsoba>) => resp.data);
};
export const dokJinaOsobaPridat = (id: number | string, data: IDokJinaOsoba) => {
    return axios({
        method: 'POST',
        url: `/DOKjiny/${id}/osoba`,
        data: data
    });
};

// omezena prevoditelnost apis

export interface IDokOmezPrevod {
    idomezprevod?: number;
    idomprevod: number;
    vyjadreni: EOmezPrevodVyjadreni;
    souhlas: boolean;
}

export const dokOmezPrevodPrikazGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKprik/${id}/omezprevod`
    }).then((resp: AxiosResponse<IDokOmezPrevod>) => resp.data);
};
export const dokOmezPrevodPrikazPut = (id: number, data: IDokOmezPrevod) => {
    return axios({
        method: 'PUT',
        url: `/DOKprik/${id}/omezprevod`,
        data: data
    });
};
